<template>
  <div class="flex items-center" :class="!!left || 'justify-center'">
    <p :class="classObject.label">
      <b>{{ displayText }}</b>
    </p>
  </div>
</template>

<script>
export default {
  props: ["status", "danger", "left"],
  computed: {
    classObject: function () {
      let classes = {
        label: [],
      };
      switch (this.status) {
        case "None":
          classes.label = ["text-gray-500"];
          break;
        case "False":
          classes.label = ["text-red-500"];
          break;
        case "True":
          classes.label = ["text-green-500"];
          break;
      }
      return classes;
    },
    displayText() {
      if (this.status === "True") {
        return "Adecuada";
      }
      if (this.status === "False") {
        return "No Adecuada";
      }
      if (this.status === "None") {
        return "Sin gestionar";
      }
      return this.status;
    },
  },
};
</script>
